export default function Footer() {
  return (
    <footer id="footer" className="bg-background-950 text-background-200">
      <div className="w-full px-4 md:px-6 py-14 md:py-16 max-w-[1280px] mx-auto">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-8 h-8 flex items-center justify-center rounded-lg bg-primary-500 text-background-50 text-sm font-bold">
                桜
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                樱花动漫之家
              </span>
            </div>
            <p className="text-sm text-background-400 leading-relaxed">
              樱花动漫之家为日漫爱好者聚合热门日本漫画资源，涵盖日漫推荐与排行。从经典神作到最新连载，满足你的追更与探索需求，打造属于漫友的温暖社区。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              快速导航
            </h4>
            <ul className="space-y-2.5">
              <li><a href="#carousel" className="text-sm text-background-400 hover:text-background-100 cursor-pointer whitespace-nowrap transition-colors">焦点专题</a></li>
              <li><a href="#ranking" className="text-sm text-background-400 hover:text-background-100 cursor-pointer whitespace-nowrap transition-colors">热门排行</a></li>
              <li><a href="#comments" className="text-sm text-background-400 hover:text-background-100 cursor-pointer whitespace-nowrap transition-colors">漫友热议</a></li>
              <li><a href="#topics" className="text-sm text-background-400 hover:text-background-100 cursor-pointer whitespace-nowrap transition-colors">话题热榜</a></li>
              <li><a href="#updates" className="text-sm text-background-400 hover:text-background-100 cursor-pointer whitespace-nowrap transition-colors">最新快讯</a></li>
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              合作伙伴
            </h4>
            <p className="text-sm text-background-500 leading-relaxed">
              樱花动漫之家致力于与优秀的日漫内容平台和创作者建立合作关系，共同打造高质量的日漫阅读生态。
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-semibold text-background-100 mb-4">
              关注我们
            </h4>
            <div className="flex gap-3 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 cursor-pointer transition-colors">
                <i className="ri-weibo-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 cursor-pointer transition-colors">
                <i className="ri-wechat-line text-lg"></i>
              </span>
              <span className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-background-300 hover:bg-primary-600 hover:text-background-50 cursor-pointer transition-colors">
                <i className="ri-bilibili-line text-lg"></i>
              </span>
            </div>
            <p className="text-xs text-background-500">
              商务合作：contact@sakura-anime.com
            </p>
          </div>
        </div>

        <div className="mt-10 pt-8 border-t border-background-800 text-center">
          <p className="text-xs text-background-500">
            &copy; {new Date().getFullYear()} 樱花动漫之家 · 所有漫画版权归原作者及出版社所有 · 本站仅做信息聚合与推荐
          </p>
        </div>
      </div>
    </footer>
  );
}